import { render, staticRenderFns } from "./taskStatus.vue?vue&type=template&id=38a5e926&"
import script from "./taskStatus.vue?vue&type=script&lang=js&"
export * from "./taskStatus.vue?vue&type=script&lang=js&"
import style0 from "./taskStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports